import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import AdminLayout from './components/Layout/AdminLayout';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Stall from './pages/Stall';
import Visitor from './pages/Visitor';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import AdminLogin from './pages/Auth/Login';
import RequireAdmin from './components/RequireAdmin';

// Admin Routes
import AdminDashboard from './pages/Admin/Dashboard';
import AdminProfile from './pages/Admin/Profile';
import AdminVisitors from './pages/Admin/Visitors';
import AdminEnquiries from './pages/Admin/Enquiries';
import AdminBlogs from './pages/Admin/Blogs/BlogList';
import AdminBlogForm from './pages/Admin/Blogs/BlogForm';
import AdminGalleries from './pages/Admin/Galleries/GalleryList';
import AdminGalleryForm from './pages/Admin/Galleries/GalleryForm';
import AdminGalleryPhotos from './pages/Admin/Galleries/GalleryPhotos';
import AdminExhibitions from './pages/Admin/Exhibitions/ExhibitionList';
import AdminExhibitionForm from './pages/Admin/Exhibitions/ExhibitionForm';
import AdminNotifications from './pages/Admin/Notifications/NotificationList';
import BannerManager from './pages/Admin/Banners/BannerManager';
import AdminTerms from './pages/Admin/Terms';
import PrintTemplates from './pages/Admin/Settings/PrintTemplates';

function App() {
  useEffect(() => {
    // Initialize any global scripts here
  }, []);

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="gallery/:categorySlug" element={<Gallery />} />
        <Route path="stall" element={<Stall />} />
        <Route path="visitor" element={<Visitor />} />
        <Route path="contact" element={<Contact />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:id" element={<BlogDetails />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
      </Route>

      {/* Auth Routes */}
      <Route path="/login" element={<AdminLogin />} />

      {/* Admin Routes - Protected with authentication */}
      <Route path="/admin" element={
        <RequireAdmin>
          <AdminLayout />
        </RequireAdmin>
      }>
        <Route index element={<AdminDashboard />} />
        <Route path="profile" element={<AdminProfile />} />
        <Route path="visitors" element={<AdminVisitors />} />
        <Route path="enquiries" element={<AdminEnquiries />} />
        <Route path="blogs" element={<AdminBlogs />} />
        <Route path="blogs/new" element={<AdminBlogForm />} />
        <Route path="blogs/edit/:id" element={<AdminBlogForm />} />
        <Route path="galleries" element={<AdminGalleries />} />
        <Route path="galleries/new" element={<AdminGalleryForm />} />
        <Route path="galleries/edit/:id" element={<AdminGalleryForm />} />
        <Route path="galleries/:id/photos" element={<AdminGalleryPhotos />} />
        <Route path="exhibitions" element={<AdminExhibitions />} />
        <Route path="exhibitions/new" element={<AdminExhibitionForm />} />
        <Route path="exhibitions/edit/:id" element={<AdminExhibitionForm />} />
        <Route path="notifications" element={<AdminNotifications />} />
        <Route path="banners" element={<BannerManager />} />
        <Route path="terms" element={<AdminTerms />} />
        <Route path="settings/print-templates" element={<PrintTemplates />} />
      </Route>
    </Routes>
  );
}

export default App;
